// extracted by mini-css-extract-plugin
export default {"wrapper":"OrderedList_wrapper__TmB1y","item":"OrderedList_item__bPdf3"};